// Design Ref: §4.1 BarChart — CSS div-based 월별 P&L
// Plan SC: FR-03 기간 필터 월별 막대
import React from 'react';

/**
 * Props:
 *  - data: [{ label: '2026-03', value: 100000 }, ...]
 *  - title?: string
 *  - height?: number (px, default 180)
 *  - formatValue?: (n) => string
 *  - positiveColor?: '#34d399'
 *  - negativeColor?: '#fb7185'
 *  - zeroColor?: '#4a5568'
 */
export default function BarChart({
  data = [],
  title,
  height = 180,
  formatValue = (n) => (n >= 0 ? '+' : '') + Math.round(n).toLocaleString(),
  positiveColor = '#34d399',
  negativeColor = '#fb7185',
  zeroColor = '#4a5568',
}) {
  if (!data.length) {
    return <EmptyBlock title={title} height={height} msg="데이터 없음" />;
  }
  const values = data.map(d => d.value);
  const max = Math.max(0, ...values);
  const min = Math.min(0, ...values);
  const absMax = Math.max(Math.abs(max), Math.abs(min), 1);

  return (
    <div style={{ background: 'var(--bg-table)', border: '1px solid var(--border-light)', borderRadius: 12, padding: '14px 16px' }}>
      {title && <div style={{ fontSize: 12, color: 'var(--text-sub)', marginBottom: 10, letterSpacing: '0.05em', textTransform: 'uppercase' }}>{title}</div>}
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, height, position: 'relative' }}>
        {/* zero line */}
        <div style={{ position: 'absolute', left: 0, right: 0, bottom: `${(Math.abs(min) / (absMax * 2 || 1)) * 100}%`, height: 1, background: zeroColor, opacity: 0.3 }} />
        {data.map((d, i) => {
          const v = Number(d.value || 0);
          const h = (Math.abs(v) / absMax) * (height - 30) * 0.95;
          const color = v === 0 ? zeroColor : v > 0 ? positiveColor : negativeColor;
          return (
            <div key={d.label + i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end', minWidth: 18 }}>
              <div title={`${d.label}: ${formatValue(v)}`} style={{
                width: '80%',
                height: Math.max(h, 1),
                background: color,
                borderRadius: '3px 3px 0 0',
                transition: 'height 0.3s ease',
                alignSelf: v >= 0 ? 'flex-end' : 'flex-start',
                marginTop: v < 0 ? `calc(100% - ${h}px)` : 0,
                cursor: 'pointer',
              }} />
              <div style={{ fontSize: 9, color: 'var(--text-sub)', marginTop: 4, fontFamily: "'DM Mono', monospace", whiteSpace: 'nowrap' }}>
                {d.label.slice(5)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function EmptyBlock({ title, height, msg }) {
  return (
    <div style={{ background: 'var(--bg-table)', border: '1px solid var(--border-light)', borderRadius: 12, padding: '14px 16px' }}>
      {title && <div style={{ fontSize: 12, color: 'var(--text-sub)', marginBottom: 10, letterSpacing: '0.05em', textTransform: 'uppercase' }}>{title}</div>}
      <div style={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-muted)', fontSize: 12 }}>{msg}</div>
    </div>
  );
}
